import { IconButton, Tooltip } from "@mui/material";
import { TOOLTIP_PROPS } from "./internalToolsUtils";
import { Castle } from "@mui/icons-material";

export function VisitCustomerMidgardAdminLink({ ckey }: { ckey: string }) {
  return (
    <Tooltip title={`↗ Midgard Admin`} {...TOOLTIP_PROPS}>
      <IconButton
        size="small"
        onClick={() => {
          window.open(
            `https://${ckey}.gke-us-east1.raven-cloud.com/midgard/admin/`,
            "_blank"
          );
        }}
      >
        <Castle />
      </IconButton>
    </Tooltip>
  );
}
